export enum TriggerSeverityLevels {
  Positive = 0,
  Mild = 1,
  Moderate = 2,
  Severe = 3,
}
